import { FC } from 'react';

const SingleProposalStyles: FC = () => {
  return (
    <style>{`
      .pr-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
  }
  .pr-w-100 {
  width: 100px;
  }
  .pr-divider {
  padding-top: 5px;
  margin-top: 10px;
  }
  .pr-text-lh {
  line-height: 1.4;
  }
  .pr-flex-row {
  display: flex;
  }
  .pr-mt-20 {
  margin-top: 20px;
  }
  .pr-mr-5 {
  margin-inline-end: 5px;
  }

.pr-h-10 {
  height: 10px;
}
.pr-notes {
  margin-top: 10px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #f3f4f5;
  line-height: 1.4;
  display: flex;
  flex-direction: column;

}
      .pr-header-single {
      line-height: 1.2;
  border: 1px solid #ddd;
  background-color: #f3f4f5;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
  }
      .pr-header-single {
        img {
          height: 38px;
          margin: -5px -10px;
          padding: 5px;
        }
      }
    .pr-hotel-card {
  border: 1px solid #ccc;
  padding: 15px;
  border-radius: 5px;
  font-size: 14px;
}
  .pr-table-wr {
    margin-top: 15px;
  }
  .pr-table {
    line-height: 1.4;
    width: 100%;
    border-collapse: collapse;
  }
  .pr-table tr:not(:last-child) {
    border-bottom: 1px solid #ddd;
  }
    .pr-status {
      padding: 4px 6px;
      border-radius: 4px;
      border: 1px solid #4a71a3;
      color: #4a71a3;
      margin-bottom: 10px;
      display: inline-block;
    }
  .pr-table th {
    font-size: 12px;
    font-weight: 600;
    padding: 6px 10px;
    text-align: left;
  }
  .pr-table td {
    font-size: 12px;
    padding: 6px 10px;
    text-align: left;
    vertical-align: middle;
    height: 53px;
  }

  
.pr-hotel-card-title {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  font-size: 16px;
  font-weight: bold;
  background-color: #f3f4f5;
  margin: -15px -15px 15px -15px;
  padding: 10px 15px;
  border-radius: 5px 5px 0 0;
  border-bottom: 1px solid #ddd;
  min-width: 0;
}
.pr-hotel-card-title-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.pr-hotel-card-title-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.3;
}
.pr-hotel-card-title-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #555;
  line-height: 1.3;
}
.pr-hotel-card-title .pr-edit-head {
  flex-shrink: 0;
  max-width: 100%;
}
.pr-hotel-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
}
.pr-hotel-content {
  display: flex;
}
.pr-hotel-image-container {
  width: 20%;
  min-width: 20%;
  height: 140px;
  margin-inline-end: 10px;
}
.pr-hotel-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
  .pr-ph-10 {
  padding: 0 10px;
  }

.pr-ph-5 {
  padding-left: 5px;
  padding-right: 5px;
}
.pr-mr-3 {
  margin-inline-end: 3px;
}
.pr-ph-3 {
  margin-inline-end: 3px;
  margin-inline-start: 3px;
}
.pr-hotel-details {
  margin-inline-start: 5px;
}
.pr-hotel-detail-row {
  margin-bottom: 7px;
}
.pr-hotel-label {
  width: 90px;
  display: inline-block;
}
.pr-hotel-value {
  font-weight: bold;
  direction: ltr;
}
.pr-hotel-flex-row {
  margin-bottom: 7px;
  display: flex;
}
.pr-hotel-uppercase {
  text-transform: uppercase;
  font-weight: bold;
}
.pr-hotel-underline {
  border-bottom: 1px solid #000;
  padding-bottom: 3px;
  display: inline-block;
}
.pr-hotel-div {
  margin-top: 20px;
  border-top: 1px solid #ddd;
  padding-top: 20px;
}
.pr-flt-logo {
  max-height: 53px;
  width: 80px;
  object-fit: cover;
  object-position: center;
  margin: -6px -10px;
}
.pr-google-images {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.pr-google-image {
  width: calc(33.33% - 7.5px);
  height: 200px;
  object-fit: cover;
}
.pr-google-image img {
  width: 100%;
  height: 100%;
}
.pr-hotel-info-block {
  margin-bottom: 20px;
}
.pr-hotel-info-block:last-child {
  margin-bottom: 0;
}
.pr-hotel-info-section {
  margin-bottom: 12px;
  line-height: 1.4;
}
.pr-hotel-info-label {
  font-weight: bold;
  margin-bottom: 4px;
}
.pr-hotel-info-text {
  line-height: 1.4;
}
.pr-hotel-info-facilities {
  line-height: 1.4;
}
.pr-hotel-info-images {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.pr-hotel-info-image {
  width: calc(33.33% - 7.5px);
  height: 200px;
}
.pr-hotel-info-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.pr-ratings {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-inline-end: 20px;
}
.pr-ratings-wr {
  display: flex;
  line-height: 1.4;
  padding: 20px;
}
.pr-ratings-number {
  font-size: 50px;
}
.pr-ratings-row {
  flex: 1;
  background-color: #ddd;
  margin: 4px 0px;
  border-radius: 4px;
  overflow: hidden;
}
.pr-ratings-row-wr {
  display: flex;
}
.pr-ratings-row-yellow {
  height: 100%;
  background-color: #efc94f;
}
.pr-ratings-star {
  flex: 0 0 70px;
}
.pr-ratings-list {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.pr-ratings-breakdown {
  display: flex;
  flex-wrap: wrap;
}
.pr-ratings-breakdown-item {
  padding: 5px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin: 0 5px 10px;
}
.pr-ratings-breakdown-item svg {
  height: 16px;
  width: 16px;
}
.pr-ta {
  line-height: 1.4;
}
.pr-ta-title {
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 10px;
}
.pr-ta-hotel-link {
  margin-bottom: 10px;
}
.pr-ta-hotel-anchor {
  font-weight: bold;
  font-size: 18px;
  text-decoration: underline;
  color: #007b8c;
}
.pr-ta-ranking {
  color: #888;
  margin-bottom: 10px;
}
.pr-ta-desc {
  margin: 10px 0;
}
.pr-ta-review-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.pr-ta-rating-img {
  margin-right: 10px;
}
.pr-ta-review-sep {
  padding: 0 10px;
}
.pr-ta-review-label {
  font-weight: bold;
  margin-bottom: 5px;
}
.pr-ta-checkbox-label {
  display: block;
  margin-bottom: 2px;
}
.pr-ta-subratings {
  margin-top: 10px;
}
.pr-ta-subrating-row {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
.pr-ta-subrating-label {
  margin-right: 8px;
  display: inline-block;
  width: 100px;
}
.pr-ta-subrating-img {
  margin-right: 8px;
}
.pr-ta-subrating-value {
  padding: 0 10px;
}
.pr-ta-amenities-label {
  font-weight: bold;
  margin-top: 10px;
}
.pr-ta-amenities-list {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  list-style: inside;
  padding: 0;
}
.pr-ta-amenity {
  width: 33.3%;
  margin: 0;
  padding: 0;
}
.pr-ta-amenities-bottom {
  margin-bottom: 20px;
}
.pr-ta-notfound {
  margin-top: 20px;
  font-weight: bold;
}
.pr-lh {
  line-height: 1.4;
}
.pr-bold {
  font-weight: bold;
  }
    .pr-rtl {
      direction: rtl;
    }
    .pr-ltr {
      direction: ltr;
    }
  .pr-template-t2 {
    .pr-hotel-card {
      border-color: #4a71a3;
    }
    .pr-hotel-card-title {
      background-color: #4a71a3;
      color: #fff;
    }
    .pr-header-single {
      border-color: #4a71a3;
      background-color: #4a71a3;
      color: #fff;
    }
  }
  .pr-template-t3 {
    .pr-hotel-card {
      border-color: #000;
    }
    .pr-hotel-card-title {
      background-color: #000;
      color: #fff;
    }
    .pr-header-single {
      border-color: #000;
      color: #fff;
      background-color: #000;
    }
  }

@media print {
  .pr-break-avoid {
    page-break-inside: avoid;
    break-inside: avoid;
    -webkit-column-break-inside: avoid;
    -webkit-page-break-inside: avoid;
  }
}
.pr-ticket {
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
  display: flex;
  flex-basis: calc(50% - 5px);
  flex-grow: 0;
  flex-shrink: 0;
  min-height: 85px;
  height: auto;
  margin-bottom: 10px;
  padding: 8px 10px;
  line-height: 1.4;
}
.pr-ticket-img {
  height: 50px;
  width: 50px;
  margin-inline-start: 10px;
  margin-bottom: 5px;
}

.pr-ticket-img img {
  border: 1px solid #590860;
  border-radius: 10px;
  height: 100%;
  width: 100%;
  box-shadow: 0 5px 10px #0000001a;
}
.pr-text-sm {
  font-size: 14px;
}
.pr-ticket-title {
  font-size: 18px;
  font-weight: bold;
}
.pr-ticket-title-1 {
  color: #590860;
}
.pr-ticket-title-2 {
  color: #000;
}
.pr-ml-a {
  margin-inline-start: auto;
}
.pr-ticket-total-date {
  color: #f57b21;
  font-weight: 600;
}
  .pr-ticket-logo {
  height: 180px;
  width: 240px;
  margin-inline-end: 10px;
}
  .pr-ticket-logo img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: center;
    border: 1px solid #590860;
    border-radius: 10px;
    box-shadow: 0 5px 10px #0000001a;
  }

.pr-ticket-cat {
  height: 50px;
  width: 100px;
  margin-inline-start: 10px;
}
   .pr-ticket-cat img {
    height: 100%;

    border: 1px solid #590860;
    border-radius: 10px;
    box-shadow: 0 5px 10px #0000001a;
    width: 100%;
    object-fit: cover;
    object-position: center;
  }
.pr-ticket-total {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.pr-ticket-total-images {
  display: flex;
}
.pr-ticket-info {
  max-width: calc(100% - 500px);
}
.pr-text-black {
  color: #000;
}
  .pr-color-danger {
    color: #ef4444;
  }
  .pr-color-success {
    color: #366e34;
  }
    .pr-text-bold {
      font-weight: bold;
    }

  `}</style>
  );
};

export default SingleProposalStyles;
